import { Pipe, PipeTransform } from "@angular/core";
import { formatDate } from "@ponder-shared/utils/general";

@Pipe({
    name: "date",
    standalone: true
})
export class FormatDatePipe implements PipeTransform {
    constructor() {

    }

    public transform(value: Date, localTime?: boolean): string {
        if (value) {
            return formatDate(value, localTime);
        } else {
            return "?";
        }
    }
}